module.exports = __webpack_public_path__ + "img/qy.20ef16dd.png";